<template>
  <div class="griditem-bd ub-f1">
    <router-link :to="path">
    <div class="icon-box">
      <slot name="icon">
        <i v-if="icon" :style="{color: color}" class="iconfont" :class="'icon-'+icon"></i>
      </slot>
      <t-badge v-if="number" class="badge" :text="number"></t-badge>
    </div>
    </router-link>
    <slot name="text">
      <p v-if="text">{{text}}</p>
    </slot>

  </div>
</template>
<script>
/**
   * @param icon [String] 图标
   * @param color [String] 图标颜色，默认#606060
   * @param text [String] 标题文字
   * @param number [String, Number] 数字角标
   * @describe 九宫格组件
   *
   * @example
   *
     <t-grid style="background-color: #ffffff; margin-bottom: 6px;">
        <t-griditem icon='orderstatus1' text='待付款' :number="0" ></t-griditem>
        <t-griditem icon='orderstatus2' text='待发货' :number="1" ></t-griditem>
        <t-griditem icon='orderstatus3' text='待收货' :number="10" ></t-griditem>
        <t-griditem icon='orderstatus4' text='已完成' :number="0" ></t-griditem>
      </t-grid>
   */

import tBadge from './badge.vue';

export default {
  name: 'tGriditem',
  props: {
    icon: { type: String, default: '' },
    color: { type: String, default: '' },
    text: { type: String, default: '' },
    path: { type: [String, Number], default: '' },
    number: { type: [String, Number], default: '' },
  },
  components: { tBadge },
};

</script>
<style scoped lang="scss">
.griditem-bd {
  padding: 0.1rem;
  .icon-box {
    position: relative;
    text-align: center;
    font-size: 0;
    i {
      font-size: 0.28rem;
      color: #000;
    }
    img {
      display: inline-block;
      width: 0.46rem;
      height: 0.46rem;
      border-radius: 50%;
      overflow: hidden;
      border: 1px solid #dedede;
    }
    .badge {
      position: absolute;
      left: 56%;
      top: -0.05rem;
    }
  }
  p {
    text-align: center;
    margin-top: 0.04rem;
    font-size: 0.12rem;
    color: #404040;
    line-height: 0.16rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/griditem.vue